import { createSelector } from "reselect"
import { getFormattedSearchOptionsForDS } from "app/static/frontend/search-new/helperFunctions"
import { selectQuorumDataType } from "app/static/frontend/search-new/selectors"
import { selectIsCommsOnlyUser } from "shared/userdata/userdata-selectors"

export const selectOrderedOptionsForSearch = createSelector(selectIsCommsOnlyUser, (isCommsOnlyUser) => {
    // getFormattedSearchOptionsForDS ensures that
    // the default_search_data_type is always the first option
    const orderedOptions = getFormattedSearchOptionsForDS(isCommsOnlyUser)
    return { orderedOptions }
})

export const selectCurrentQdtIndex = createSelector(
    selectQuorumDataType,
    selectOrderedOptionsForSearch,
    (searchQdt, { orderedOptions }) => {
        return orderedOptions.findIndex((option) => option.value === searchQdt)
    },
)
